import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'
import { Paragraph } from '@components/Text'

export const ProposalActions = styled.section`
  display: flex;
  justify-content: space-around;
  margin-top: 40px;
  margin-bottom: 48px;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    margin-top: 80px;
    margin-bottom: 0px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 32px;
    margin-bottom: 104px;
    justify-content: flex-start;
  }
`

export const ProposalActionsItem = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: auto;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    flex-direction: row;
    margin-right: 16px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-right: 32px;
  }
`

export const ProposalActionsDescription = styled(Paragraph)`
  flex: 1;
  font-style: normal;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  margin: 8px 0 0;
  color: var(--vibin);
  text-align: left;
  margin-left: 8px;
  letter-spacing: 0.5px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 0px;
  }
`
